<h1 class="welcome-heading" *transloco="let t">
  {{
    config.tenant === tenants.FR ? "Bienvenue" : t("taxpayersSearch.welcome")
  }}, {{ userInfo.firstName }}
</h1>

<app-search-field
  id="search-all-taxpayers"
  class="search-field"
  [formGroup]="rootForm"
  placeholder="{{ searchPlaceholder }}"
></app-search-field>
<div class="search-dropdowns">
  @if (taxYearOptions) {
  <app-search-dropdown
    id="tax-year-dropdown"
    class="tax-year"
    label="{{ yearLabel }}"
    [formGroup]="rootForm"
    [formCtrl]="rootForm.controls['taxYearForm']"
    [placeholder]="taxYearOptions[0].value"
    [listOptions]="taxYearOptions"
  ></app-search-dropdown>
  } @if (rootForm.controls['taxReturnStatusForm']) {
  <app-search-dropdown
    id="tax-return-status-dropdown"
    class="tax-return-status"
    label="{{ taxReturnAlias }} {{ 'taxpayersSearch.status' | transloco }}"
    [formGroup]="rootForm"
    [formCtrl]="rootForm.controls['taxReturnStatusForm']"
    [placeholder]="taxReturnStatusOptions[0].value"
    [listOptions]="taxReturnStatusOptions"
  ></app-search-dropdown>
  } @if (showTaxReturnType && rootForm.controls['taxReturnTypesForm']) {
  <app-search-dropdown
    id="tax-return-type-dropdown"
    class="tax-return-type"
    label="{{ taxReturnAlias }} {{ 'taxpayersSearch.type' | transloco }}"
    [formGroup]="rootForm"
    [formCtrl]="rootForm.controls['taxReturnTypesForm']"
    [placeholder]="taxReturnTypeList[0].value"
    [listOptions]="taxReturnTypeList"
  ></app-search-dropdown>
  } @if (showTaxReturnType && rootForm.controls['taxReturnSubtypesForm']) {
  <app-search-dropdown
    id="tax-return-subtype-dropdown"
    class="tax-return-subtype"
    label="{{ taxReturnAlias }} {{ 'taxpayersSearch.subtype' | transloco }}"
    [formGroup]="rootForm"
    [formCtrl]="rootForm.controls['taxReturnSubtypesForm']"
    [placeholder]="taxReturnSubtypeList[0].value"
    [listOptions]="taxReturnSubtypeList"
  ></app-search-dropdown>
  }
</div>

@if (searchErrorMessage) {
<div class="error">
  {{ searchErrorMessage }}
</div>
}

<!-- all these containers are needed to center the spinner properly without taking up vertical space-->
@if (searching) {
<div class="loader-container-outer">
  <div class="loader-container-inner">
    <div class="ui active centered inline loader"></div>
  </div>
</div>
} @if (!searchErrorMessage) {
<div class="no-results">
  @if (assignees && assignees.length === 0) {
  <div>{{ "taxpayersSearch.no-results-found" | transloco }}</div>
  }
</div>
<app-taxpayer-list
  [assignees]="assignees || []"
  [showTaxReturnType]="showTaxReturnType"
  (refreshRequired)="doSearch()"
  [showQnrType]="showQnrType"
></app-taxpayer-list>
}
